module.exports = __webpack_public_path__ + "static/media/AI语音banner.804bf2ec.jpg";